import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=04fe715e&scoped=true"
var script = {}
import style0 from "./NextButton.vue?vue&type=style&index=0&id=04fe715e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fe715e",
  null
  
)

export default component.exports